import { SVGProps } from 'react';

export const User = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0004 8.38306C10.2064 8.38306 12.0004 6.58906 12.0004 4.38306C12.0004 2.17706 10.2064 0.383057 8.0004 0.383057C5.7944 0.383057 4.0004 2.17706 4.0004 4.38306C4.0004 6.58906 5.7944 8.38306 8.0004 8.38306Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0004 9.38306C3.2904 9.38306 0.000396729 11.8501 0.000396729 15.3831V16.3831H16.0004V15.3831C16.0004 11.8501 12.7104 9.38306 8.0004 9.38306Z"
      fill="currentColor"
    />
  </svg>
);
